export const cleaningAreaQueryKeys = {
  all: ['cleaning-areas'] as const,
  list: () => ['cleaning-areas', 'list'] as const,
  closurePeriods: (areaId: string) => ['cleaning-areas', 'closure-periods', areaId] as const,
  allAreasClosurePeriods: () => ['cleaning-areas', 'all-areas-closure-periods'] as const,
};
